// src/data/certificates.js
export const certificateData = [
    {
        title: "Internet of Things",
        issuer: "Innovatory Bussiness LLP",
        date: " 30th October 2024",
        link: "/certificates/IoT-Lokesh.pdf",
    },
    {
        title: "Full stack Java ",
        issuer: "Udemy",
        date: "3rd November 2023",
        link: "/certificates/JAVA-cirtificate-Lokesh.pdf",
    },
    {
        title: "Accounting fundamentals",
        issuer: "TCS ion",
        date: "21st April 2024",
        link: "/certificates/Accounting_fundamentals.pdf",
    },
    {
        title: "Cloud Architecting",
        issuer: "AWS Academy",
        date: "05th August 2024",
        link: "/certificates/AWS_Academy_Graduate___AWS_Academy_Cloud_Architecting_Badge20240508-8-d5hpvy.pdf",
    },
    {
        title: "Introduction to Cloud",
        issuer: "AWS Academy",
        date: "27th December 2022",
        link: "/certificates/AWS_Academy_Graduate___AWS_Academy_Introduction_to_Cloud_Semester_1_Badge20231202-29-geio1u.pdf",
    },
    {
        title: "AWS job roles",
        issuer: "AWS",
        date: "12th Dec 2022",
        link: "/certificates/AWS-job-roles-in-cloud.pdf",
    },
    {
        title: "Cloud practitioner essentials",
        issuer: "AWS",
        date: "12th December 2022",
        link: "/certificates/Cloud-practitioner-essentials.pdf",
    },
    {
        title: "Apply AI Analyze Customer Reviews",
        issuer: "Cisco",
        date: "23th December 2025",
        link: "/certificates/Apply_AI-_Analyze_Customer_Reviews_.pdf",
    },
    {
        title: "Networking Basics Indore",
        issuer: "Cisco",
        date: "20th December 2025",
        link: "/certificates/Networking_Basics_Indore.pdf",
    },
    {
        title: "Cyber Security",
        issuer: "Cisco",
        date: "28th November 2025",
        link: "/certificates/Cyber_Security.pdf",
    },
    {
        title: "Cisco Modern AI",
        issuer: "Cisco",
        date: "9th December 2025",
        link: "/certificates/Cisco_Modern_AI.pdf",
    },
    {
        title: "Network Defense",
        issuer: "Cisco",
        date: "23th December 2025",
        link: "/certificates/Network_Defense.pdf",
    },
    {
        title: "Python Programming",
        issuer: "Red Hat",
        date: "12th November 2025",
        link: "/certificates/Python_programming.pdf",
    },
    {
        title: "Programming in Java",
        issuer: "Ret Hat",
        date: "18th December 2025",
        link: "/certificates/Programming_in_Java.pdf",
    },
    {
        title: "Red Hat System Administrator",
        issuer: "Red Hat",
        date: "7th December 2025",
        link: "/certificates/System_Administrator.pdf",
    },


    // more certificates...
];
